import { TenantDTO } from '../domain/tenant';
import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';

export class ChiaviDTO extends LogicalDeleteDTO{
	
	id: number;
    tenant: TenantDTO;
    descrizione: String;

}